import { createSelector } from "reselect";

export const getRequesting = ({ Help_reducer }) => {
    return Help_reducer.requesting;
};
export const getFeatures = ({ Help_reducer }) => {
    return Help_reducer.features;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["help"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectFeature = createSelector([getFeatures], (features) => {
    if (
        features === false ||
        typeof features === "undefined" ||
        features === null
    ) {
        return [];
    }

    let regFeatures = Object.keys(features).map((e) => {
        return features[e];
    });
    return regFeatures;
});
